import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'md-modal-content',
  templateUrl: './modal-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalContentComponent {}
